// @flow
import React from "react";
import { Form } from "semantic-ui-react";
import { Field } from "redux-form";

import FormLabel from "Commons/Components/FormComponents/components/FormLabelWithDivider";
import { nameValidator } from "../../ChangeServices/submodules/Old_Edit/misc/Validators";
import { InputField } from "../../ChangeServices/submodules/Old_Edit/components/Fields";

type Props = {
  fields: Dict,
  t: typeof TFunction,
  noLabel?: boolean,
  width?: number,
  divider?: boolean,
};
export const LastName = ({ noLabel, fields, t, width = 10, divider }: Props) => {
  return (
    <Form.Group>
      {!noLabel && (
        <FormLabel
          divider={divider}
          id={fields.lastName}
          title={t("common:lastName")}
          inline
          tooltip={t("mobile.customer.addressDetails.lastNameInfo")}
          secondary
        />
      )}
      <Field
        name={fields.lastName}
        validate={nameValidator}
        component={InputField}
        props={{
          id: fields.lastName,
          placeholder: t("common:lastName"),
          width: width,
        }}
      />
    </Form.Group>
  );
};

export const FirstName = ({ noLabel, fields, t, width = 10, divider }: Props) => {
  return (
    <Form.Group>
      {!noLabel && (
        <FormLabel
          divider={divider}
          id={fields.firstName}
          title={t("common:firstName")}
          inline
          tooltip={t("mobile.customer.addressDetails.firstNameInfo")}
          secondary
        />
      )}
      <Field
        name={fields.firstName}
        validate={nameValidator}
        component={InputField}
        props={{
          id: fields.firstName,
          placeholder: t("common:firstName"),
          width: width,
        }}
      />
    </Form.Group>
  );
};
